export default {
    namespaced: true,
    state: {
        accesses: [],
        pagination: {
            page: 1,
            totalPages: 1,
            totalRecords: 0,
            pageSize: 10
        },
        statuses: {
            new: 'new',
            approved: 'approved',
            forbidden: 'forbidden'
        },
        errors: {
            accesses: {},
            approveAccess: {},
            rejectAccess: {}
        }
    },
    mutations: {
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        },
        SET_PAGINATION(state, payload) {
            state.pagination[payload.key] = payload.val
        },
        SET_ACCESSES(state, payload) {
            state.accesses = payload
        }
    },
    actions: {
        async getAccesses({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'accesses',
                val: ''
            })

            const url = '/supplier/brands/access'

            try {
                const resp = await this.$axios.get(url, {
                    params: data
                })

                commit('SET_ACCESSES', resp.data)

                commit('SET_PAGINATION', {
                    key: 'page',
                    val: resp.headers['page'] * 1
                })
                commit('SET_PAGINATION', {
                    key: 'totalPages',
                    val: resp.headers['total-pages'] * 1
                })
                commit('SET_PAGINATION', {
                    key: 'totalRecords',
                    val: resp.headers['total-records'] * 1
                })
                commit('SET_PAGINATION', {
                    key: 'pageSize',
                    val: resp.headers['page-size'] * 1
                })
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'accesses',
                        val: e.response.data
                    })
                }
            }
        },
        async approveAccess({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'approveAccess',
                val: ''
            })

            const url = '/supplier/brands/access'

            try {
                const resp = await this.$axios.post(`${url}/${data}`)
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'approveAccess',
                        val: e.response.data
                    })
                }

                throw e
            }
        },
        async rejectAccess({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'rejectAccess',
                val: ''
            })

            const url = '/supplier/brands/access'

            try {
                const resp = await this.$axios.delete(`${url}/${data}`)
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'rejectAccess',
                        val: e.response.data
                    })
                }

                throw e
            }
        }
    }
}
